import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SeqPageTitlesService } from './page-titles.service';

export function getTranslationFiles(): string[] {
    return ['dashboard', 'forms', 'general', 'groups', 'inventory', 'layout', 'orders', 'table'];
}

export function appInitializerFactory(
    translate: TranslateService,
    seqPageTitlesService: SeqPageTitlesService,
    injector: Injector
) {
    return () => {
        seqPageTitlesService;
        new Promise<any>((resolve: any) => {
            const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
            locationInitialized.then(() => {
                const langToSet = 'en';
                const translationParts = getTranslationFiles();
                translate.setDefaultLang(langToSet);
                translate.use(langToSet).subscribe(
                    () => {
                        translationParts.forEach(part => {
                            translate.getTranslation('en/' + part).subscribe(translations => {
                                translate.setTranslation(langToSet, translations, true);
                            });
                        });
                        resolve(null);
                    },
                    _err => {
                        console.error(`Problem with '${langToSet}' language initialization.`);
                        resolve(null);
                    }
                );
            });
        });
    };
}
